import { createSelector } from '@reduxjs/toolkit'

import { AppState } from '..'
import { FormNames } from '../../models/form/IFormDefinition'
import { BasicInfoFieldsNames } from '../../formDefinitions/BasicInfo/BasicInfoFields'



// =========================================== SZCZEGÓŁOWE SELEKTORY DO KONKRETNYCH WARTOŚCI =========================================== //
export const selectUserEmailFromState = createSelector(
   [(state: AppState) => state.formState, (state) => state.applicationState],
   (formState, applicationState): string => {
      const rawTrimmedEmailFromFormState = (formState[FormNames.BasicInfoForm].fieldsData[BasicInfoFieldsNames.Email].value as string).trim()

      if(rawTrimmedEmailFromFormState.length > 0){
         return rawTrimmedEmailFromFormState
      }
      else if(applicationState.userEmailFromHub !== undefined && applicationState.userEmailFromHub.trim().length > 0){
         return applicationState.userEmailFromHub
      }
      else {
         console.error("Brak poprawnego adresu email zarówno w formState jak i applicationState.")
         return ''
      }
   }
)